


































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DataUtility from "@/services/DataUtility";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SuratRujukanBalikHaji from "@/services/SuratRujukanBalikHaji";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalSuratRujukanBalikHaji extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: () => null }) existing!: any;
  @Prop({ default: () => ({}) }) pasien!: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  required = [v => !!v || "*Kolom ini harus diisi"];
  formValid = true;
  saving = false;

  listFaskes: any[] = [];
  searchFaskes = "";

  tujuan: { id: number; nama: string } | null = null;
  unit_tujuan_text = "Sejawat Dokter Pemeriksa Kesehatan Dasar";
  bin_binti = "";
  alamat_text = "";
  kab_kota = "";
  no_telp_kontak = "";
  diagnosis = "";
  terapi_diberikan = "";
  terapi_diharapkan = "";
  dokter_id: number | null = null;

  get dialog(): boolean {
    return this.value;
  }
  set dialog(v: boolean) {
    this.$emit("input", v);
  }
  get listDokter() {
    return storeDokter.list;
  }
  get storeUser() {
    return userModule.user;
  }
  get placeholderAlamat() {
    return this.pasien?.alamat ? `Default: ${this.pasien.alamat}` : "Alamat tempat tinggal jemaah";
  }
  get placeholderKabKota() {
    return this.pasien?.wilayah ? `Default: ${this.pasien.wilayah}` : "Kabupaten / Kota";
  }
  get placeholderTelp() {
    return this.pasien?.telp ? `Default: ${this.pasien.telp}` : "Nomor telepon yang bisa dihubungi";
  }

  mounted() {
    this.loadFaskes();
  }

  @Watch("value")
  onOpen(v: boolean) {
    if (v) {
      this.hydrate();
    }
  }

  hydrate() {
    if (this.existing) {
      this.tujuan = this.existing.tujuan ?? null;
      this.unit_tujuan_text = this.existing.unit_tujuan_text || "Sejawat Dokter Pemeriksa Kesehatan Dasar";
      this.bin_binti = this.existing.bin_binti || "";
      this.alamat_text = this.existing.alamat_text || "";
      this.kab_kota = this.existing.kab_kota || "";
      this.no_telp_kontak = this.existing.no_telp_kontak || "";
      this.diagnosis = this.existing.diagnosis || "";
      this.terapi_diberikan = this.existing.terapi_diberikan || "";
      this.terapi_diharapkan = this.existing.terapi_diharapkan || "";
      this.dokter_id = this.existing.dokter?.id ?? null;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    this.tujuan = null;
    this.unit_tujuan_text = "Sejawat Dokter Pemeriksa Kesehatan Dasar";
    this.bin_binti = "";
    this.alamat_text = "";
    this.kab_kota = "";
    this.no_telp_kontak = "";
    this.diagnosis = "";
    this.terapi_diberikan = "";
    this.terapi_diharapkan = "";
    this.dokter_id = this.storeUser?.profesi === "Dokter" ? this.storeUser.id : null;
  }

  async loadFaskes() {
    const data = await DataUtility.getListFaskes();
    this.listFaskes = data as any[];
  }

  get payload() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      tujuan_id: this.tujuan?.id,
      unit_tujuan_text: this.unit_tujuan_text,
      dokter_id: this.dokter_id,
      unit_id: userModule.user.unit_id,
      bin_binti: this.bin_binti,
      alamat_text: this.alamat_text,
      kab_kota: this.kab_kota,
      no_telp_kontak: this.no_telp_kontak,
      diagnosis: this.diagnosis,
      terapi_diberikan: this.terapi_diberikan,
      terapi_diharapkan: this.terapi_diharapkan
    };
  }

  async save() {
    if (this.readOnly) return;
    if (this.saving) return;
    if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) return;

    this.saving = true;
    try {
      const resp = this.existing?.id
        ? await SuratRujukanBalikHaji.update(this.existing.id, this.payload)
        : await SuratRujukanBalikHaji.create(this.payload);

      if (resp?.data?.status) {
        appModule.NoticeDelay("Berhasil menyimpan Surat Rujukan Balik Haji");
        this.$emit("saved", resp.data.data);
        this.dialog = false;
      }
    } finally {
      this.saving = false;
    }
  }
}
